import { Component } from '@angular/core';
import { TranslateService } from './core/services/translate.service';
import { NavigationEnd, Router } from '@angular/router';
import { pdfDefaultOptions } from 'ngx-extended-pdf-viewer';
 
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'portal-client';

  constructor(private router : Router,private translateService : TranslateService){
    pdfDefaultOptions.assetsFolder = 'bleeding-edge';

  }

  ngAfterViewInit(): void {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        setTimeout(() => {
          this.translateService.triggerTranslation();
        }, 300); // Let DOM settle before translating
      }
    });
  }
 

} 


